import styled from "@emotion/styled";
import { Accordion, Button, Tabs } from "@mui/material";
import colors from "theme/colors";
import { NewText } from "ui";

export const BaseButton = styled(Button)`
display: flex;
flex-direction: column-reverse;
align-items: center;
gap: 10px;
background-color: #0050C9;
color: white;
padding: 10px 8px;
&:hover {
  background-color: #0050C9 !important;
  }
  border-radius: 8px;
  ${(props) => props.theme.breakpoints.up("md")} {
    border-radius: 30px;
    flex-direction: row;
  }
`;

export const ButtonLayout = styled(Button)`
width: 215px;
background-color: #0050C9;
color: white;
padding: 10px 8px;
display: flex;
gap: 10px;
font-size: 16px;
&:hover {
  background-color: #0050C9 !important;
  }
  border-radius: 24px;
margin-bottom: 40px;
${(props) => props.theme.breakpoints.up("md")} {
  margin-bottom: 30px;
    padding: 10px 8px;
  }
  span{
    color: white;
  }
`;



export const StyledButton = styled.div <{ selected: boolean, mobileWidth?: number }>`
  background-color: ${({ selected }) => (selected ? "#0050C9" : "#FFF")};
  opacity: ${({ selected }) => (selected ? 1 : 0.5)};
  color: ${({ selected }) => (selected ? "#FFF" : "#0050C9")} !important;
  &:hover {
    background-color: ${({ selected }) => (selected ? "#0050C9" : "#FFF")} !important;
  }
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
    gap: 5px;
    padding: 8px;
    border-radius: 8px;
    font-size: 20px;
    width: ${({ mobileWidth }) => `${mobileWidth || 140}px`};
    height: 80px;
    ${(props) => props.theme.breakpoints.up("md")} {
       width: 187px;
      height: 39px;
      flex-direction: row;
      padding: 10px;
      border-radius: 30px;
          font-size: 15px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    font-size: 20px;
         width: 249px;
      height: 52px;
  }

`;

export const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid #E4F2FF;
  margin-top: 20px;
  min-height: 0;
  padding: 8px 8px 20px 8px;
  width: 100%;
  .MuiTabs-flexContainer{
    ${(props) => props.theme.breakpoints.down("md")} {
  justify-content: space-between;
  }
  display: flex;
      gap: 16px;
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-bottom: 8px;
    margin-top: 16px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    margin-top: 24px;
    padding-top: 8px;
  }
  .MuiTab-root {
    min-height: 0;
    height: fit-content;
    color: ${colors.black};
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    padding: 0px;

    /* box-shadow: inset 6px solid transparent; */
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 16px;
      margin: 0;
      // padding: 0px 33.33px 8px 33.33px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      font-size: 24px;
      margin: 0;
      // padding: 0px 50px 12px 50px;
    }
  }
  .Mui-selected {
    // box-shadow: inset 0 -6px 0 0 ${colors.yellow};
    color: ${colors.black};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 16px;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
      font-size: 24px;
    }
  }
`


export const StyledTabPanelWrapper = styled.div`
padding-top: 40px;
padding-bottom: 40px;
    ${(props) => props.theme.breakpoints.only("md")} {
        padding-bottom: 20px;
      p{
        margin: 0px;
      }
    }
    ${(props) => props.theme.breakpoints.up("md")} {

      padding-top: 24px;
      & > p:first-child {
        padding-bottom: 16px;
        }
        font-size: 14px;
        }
        a{
          color: #0050C9;
          }
          ${(props) => props.theme.breakpoints.up("lg")} {
            padding-top: 44px;
      }
`;
export const StyledContactTextCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 30px;
  row-gap: 30px;
  h3{
    font-weight: 500 !important;
    }
    ${(props) => props.theme.breakpoints.up("md")} {
      grid-template-columns: 1fr 1fr;
  }
  a{
    color: #0050C9;
  }
`;
export const StyledDeatilsText = styled(NewText)`
  margin: 0px;
  p{
  margin: 0px;
  }
`;

export const StyledShareIconWrapper = styled.div`
padding-top: 3px;
padding-right: 10px;
`;
export const StyledAccordion = styled(Accordion)`
  box-shadow: none;
  & > .MuiAccordionSummary-root{
    box-shadow: 0px 10px 25px 0px #0000000F;
    min-height: 64px;
    margin-bottom: 20px;
    ${(props) => props.theme.breakpoints.up("md")} {
      border-bottom: 1px solid #B9C5D2;
      margin-bottom: 0px;
    }
  }
      ${(props) => props.theme.breakpoints.up("md")} {
    border: 1px solid #F5F5F5;
    }

  `
export const StyledAccordionWrapper = styled.div`
margin-left: -20px;
width: calc(100% + 40px);
  box-sizing: border-box;
  padding-bottom: 25px;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-left: 0px;
    width: auto;
    }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-bottom: 30px;
    }

`
export const StyledMobileForm = styled.div`
  padding-top: 40px;
  padding-bottom: 80px;
`
export const StyledNewText = styled(NewText)`
  strong {
    font-weight: 600;
  }
    border-bottom: 1px solid #E4F2FF;
    ${(props) => props.theme.breakpoints.up("md")} {
      border-bottom: 1px solid #B9C5D2;
      font-size: 14px;
      }
      ${(props) => props.theme.breakpoints.up("lg")} {
        font-size: 16px;
    }
`;
